<template>
  <job-request-pane>
    <template slot="title">
      <template v-if="isTouched">
        <template v-if="selectedPublicProfilesIds.length">
          <span selenium="page-title-text">
            We found {{ matchedPublicProfilesIds.length }}
            pros that match with your project.
          </span>
        </template>
        <template v-else>
          Please choose at least 1 pro.
        </template>
      </template>
      <template v-else>
        We've matched you with qualified pros!
      </template>
    </template>
    <template slot="subtitle">
      Each pro has been matched based on their specialty, availability, and customer feedback.
    </template>
    <template slot="content">
      <div class="d-flex fd-column">
        <!-- Pre Selected Pros -->
        <div class="d-flex ai-center" >
          <span class="c-gray90 text-bold">Preselected Pros({{ selectedPublicProfilesIds.length}}
            of {{  matchedPublicProfilesIds.length  }}) </span>
          <span class=" m-l-1 CHECKBOXSQUARE">
            <img width="20" src="./assets/Padding.svg"/>
          </span>
          <span class="m-l-1 c-gray90 text-400 text-sm as-center">Select/de-select Pros
          you’d like to contact.You may select up to 5 Pros to match.</span>
        </div>
        <div class="d-flex m-t-1" >
          <img width="24" src="./assets/Vector.svg"/>
          <span class="m-l-1 TEXTDISCALIMER c-gray90 text-600 text-sm">Prices listed are
          estimates of the labor cost. Material costs may vary by project.</span>
        </div>
        <div class="p-y-3 m-b-2">
          <pro-cards-container
              :service-display-name="service.display_name"
              :public-profile-ids="preSelectedPublicProfilesIds"
              :pricingValue="checkPricingList"
              @toggleSelection="toggleSelectedPublicProfile"
              @updateTopPro="showTopPro=true"/>
        </div>
        <!-- credentials-->
        <div class="p-2 bg-white ">
          <credential-guide :showTopPro="showTopPro" />
        </div>

        <div class="d-flex m-y-2 jc-center text-bold">
          <p v-if="nonPreSelectedPublicProfilesIds.length">More Pros that match with your project
          description, choose up to 5 pros that can reach out you in the next few days.</p>
        </div>
        <!-- Other Pros -->
        <div class="bg-white p-4 m-b-2">
          <pro-cards-container
              v-if="nonPreSelectedPublicProfilesIds.length"
              :public-profile-ids="nonPreSelectedPublicProfilesIds"
              @toggleSelection="toggleSelectedPublicProfile"/>

          <pro-cards-container
              v-if="shouldShowMoreProfiles"
              :public-profile-ids="extraSelectedPublicProfileIds"
              @toggleSelection="toggleSelectedPublicProfile"/>
        </div>
        <div
            v-if="extraSelectedPublicProfileIds.length "
            :class="{ 'btn m-x-auto btn-secondary': !shouldShowMoreProfiles }"
            selenium="show-more-button"
            @click="showMoreProfiles">
          {{ moreProsText }}
        </div>

      </div>
    </template>
  </job-request-pane>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import JobRequestPane from '@/views/JobRequest/components/JobRequestPane';
import ProCardsContainer from './components/ProCardsContainer';
import CredentialGuide from './components/CredentialGuide';

export default {
  name: 'pro-selection',
  components: {
    JobRequestPane,
    ProCardsContainer,
    CredentialGuide,
  },
  data () {
    return {
      showTopPro: false,
    };
  },
  computed: {
    ...mapGetters('account/pro/pricing', [
      'pricingList',
    ]),
    ...mapGetters('jobrequest', ['service']),

    ...mapGetters('homepage/hierarchies', [
      'serviceHierarchies',
    ]),
    ...mapGetters('homepage/request', ['selectedService']),
    ...mapGetters('account'),
    ...mapGetters('jobrequest/matches', [
      'selectedPublicProfilesIds',
      'nonPreSelectedPublicProfilesIds',
      'extraSelectedPublicProfileIds',
      'matchedPublicProfilesIds',
      'maxSelectedProfiles',
      'preSelectedPublicProfilesIds',
      'isTouched',
      'shouldShowMoreProfiles',
    ]),
    moreProsText () {
      if (!this.shouldShowMoreProfiles && this.extraSelectedPublicProfileIds.length) {
        return `See ${this.extraSelectedPublicProfileIds.length} more Pros`;
      }
    },
    checkPricingList () {
      if (!this.selectedService
      || !this.selectedService.occupations || this.selectedService.occupations.length === 0) {
        console.error('selectedService or occupations is not defined or empty');
        return;
      }

      const occupationId = this.selectedService.occupations[0].id;
      if (!this.pricingList[occupationId]) {
        console.error('Pricing list does not contain this occupation ID');
        return;
      }
      return this.pricingList[occupationId].pricing;
    },
  },
  async mounted () {
    if (Object.keys(this.pricingList).length === 0) {
      await this.fetchPricingList();
    }
  },
  methods: {
    ...mapActions('account/pro/pricing', ['fetchPricingList']),
    ...mapActions('jobrequest/matches', [
      'toggleSelectedPublicProfile',
    ]),
    showMoreProfiles () {
      this.$store.commit('jobrequest/matches/showMoreProfiles');
    },
  },
};


</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

   .CHECKBOXSQUARE{
    width: 21px;
    height: 21px;
    border:1px solid $color-depot;
    background: $color-depot;
    border-radius: 5px;
    display: flex;
  }
  .CIRCLE{
    @include circle (24px);
    background-color: red;
  }
  .TEXTDISCALIMER{
    font-size: 10px;
    margin-top: 6px;
  }
  </style>
